import {EventEmitter, Input, Output} from '@angular/core';
import {QuestionInfo, QuestionModel} from '../model/question.model';

export abstract class QuestionInput {

  @Input()
  public question;

  @Output()
  public questionAnswered = new EventEmitter();



  abstract get answer(): any;

}
